/**
 * Phase 9.2 — compact language switcher.
 *
 * Reads / writes the active language via `i18n.changeLanguage`, which
 * persists to localStorage under `ckos.lang` (see `src/lib/i18n.ts`).
 */
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { SUPPORTED_LANGUAGES } from "@/lib/i18n";

const LABELS: Record<string, string> = { en: "EN", fr: "FR", de: "DE" };

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage ?? "en").slice(0, 2);

  return (
    <label
      className="btn-ghost inline-flex cursor-pointer items-center gap-1"
      title={t("actions.language", { defaultValue: "Language" })}
    >
      <Languages size={16} aria-hidden />
      <select
        aria-label={t("actions.language", { defaultValue: "Language" })}
        value={SUPPORTED_LANGUAGES.includes(current as never) ? current : "en"}
        onChange={(e) => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          i18n.changeLanguage(e.target.value);
        }}
        className="cursor-pointer bg-transparent text-xs outline-none"
      >
        {SUPPORTED_LANGUAGES.map((lng) => (
          <option key={lng} value={lng}>{LABELS[lng] ?? lng.toUpperCase()}</option>
        ))}
      </select>
    </label>
  );
}
